import React from 'react'
import type { TableFilterProps } from './Context'
import { TableFilterProvider } from './Context'
import { FilterButton } from './FilterButton'

export const TableFilter = (props: TableFilterProps) => {
  return (
    <TableFilterProvider {...props}>
      <FilterButton />
    </TableFilterProvider>
  )
}
